import React, { useContext } from "react";
import { GameStatus } from "../constants";

const initialState = {};

const TimerContext = React.createContext(initialState);

/*
*
* This Provider will make all the children to re-render every seconds, Be Careful.
*
*/
function TimerProvider({ children }) {
  const [tick, setTick] = React.useState(0);

  React.useEffect(() => {
    let timer = setTimeout(() => {
      setTick(tick + 1);
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [tick]);

  return (
    <TimerContext.Provider value={tick}>{children}</TimerContext.Provider>
  );
}

export const useTimerContext = () => useContext(TimerContext);

export default TimerProvider;
